export const MESSAGE_METHOD = {
  CLOSE_REMOTE_COMPONENT: 'closeRemoteComponent',
  REMOTE_COMPONENT_READY: 'remoteComponentReady',
  REPORT_REMOTE_COMPONENT_ERROR: 'reportRemoteComponentError',
} as const;

export const MESSAGE_ID = {
  ACCESS_GATE: 'access-gate',
} as const;

export const ERROR_CODES = {
  LEAD_UUID_NOT_PRESENT: 100,
  INVALID_ENTITY_TYPE: 101,
  ENTITY_DATA_MISSING: 102,
  EVENT_ID_MISSING: 103,
  LEAD_CAPTURE_FORM_FETCHING_FAILED: 104,
  ERROR_UPDATING_LEAD: 105,
  LEAD_LOGIN_ERROR: 106,
  LEAD_CAPTURE_FORM_DATA_FETCHING_FAILED: 107,
} as const;
